$(document).ready(function () {
  var $equalHeightRows = $(".set-equal-height-cols, .set-equal-height-cols-sm, .set-equal-height-cols-md");
  $equalHeightRows.each(function () {
    var $columns = $(this).children();
    var breakpoint = getBreakpoint($(this));

    equalizeHeights($columns, breakpoint);

    $(window).on("load resize", function () {
      equalizeHeights($columns, breakpoint);
    });

  });
});

function equalizeHeights($columns, breakpoint) {
  if(!$columns) return;

  // dont equalize if greater than breakpoint
  if(($(window).width() <= breakpoint)) {
    $($columns).css("height", "auto");
    return;
  }

  // equalize
  var maxHeight = -1;
  $($columns).height("auto");
  $($columns).each(function () {
    maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
  });
  $($columns).height(maxHeight);

}

function getBreakpoint(row) {
  if ($(row).hasClass("set-equal-height-cols")) return 1;
  if ($(row).hasClass("set-equal-height-cols-sm")) return breakpoints.small;
  if ($(row).hasClass("set-equal-height-cols-md")) return breakpoints.medium;
}